import React, { useRef, useState } from 'react';
import { CircleCheck, Clock, Search } from "lucide-react";
import { Select, Input } from "antd/lib";
import { FilterType, INoteToolbar, SortType } from "../type/my-notes-page.types";
import notes from "../../../resources/notes";


const Toolbar: React.FC<INoteToolbar> = (props) => {

    const resource = notes;
    const timerRef = useRef<any>(null);
    const [activeFilter, setActiveFilter] = useState<FilterType>('all');

    const sortOptions = [
        {
            label: 'Newest first',
            value: 'descending'
        },
        {
            label: 'Oldest first',
            value: 'ascending'
        },
        {
            label: 'By Priority',
            value: 'priority'
        },
        {
            label: 'Alphabetical',
            value: 'alphabetical'
        }
    ];

    function handleButtonClick(type: FilterType) {
        setActiveFilter(type);
        props.loadNotes({filter: type});
    }

    function handleSearch(e: any) {
        const value = e.target.value;

        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        timerRef.current = setTimeout(() => {
            props.loadNotes({filter: activeFilter, search: value});

        }, 500);
    }

    return (
        <div className={'hrms-notes__toolbar'}>
            <Input
                className={'hrms-notes__search-bar'}
                placeholder={resource.searchBarPlaceholder}
                allowClear
                prefix={<Search className={'search-icon'}/>}
                onChange={(e) => handleSearch(e)}
            />
            <div className={'hrms-notes__actions'}>
                <button
                    className={`hrms-notes__btn default 
                    ${activeFilter === 'all' ? 'active' : ''}`}
                    onClick={() => handleButtonClick('all')}>
                    {resource.allNotesBtnText}
                </button>
                <button
                    className={`hrms-notes__btn priority 
                    ${activeFilter === 'priority' ? 'active' : ''}`}
                    onClick={() => handleButtonClick('priority')}>
                    <span className={'high-priority-icon'}/>
                    {resource.highPriorityNotesBtnText}
                </button>
                <button
                    className={`hrms-notes__btn scheduled 
                    ${activeFilter === 'scheduled' ? 'active' : ''}`}
                    onClick={() => handleButtonClick('scheduled')}>
                    <Clock className={'clock-icon'}/>
                    {resource.scheduledNotesBtnText}
                </button>
                <button
                    className={`hrms-notes__btn completed
                     ${activeFilter === 'completed' ? 'active' : ''}`}
                    onClick={() => handleButtonClick('completed')}>
                    <CircleCheck className={'complete-icon'}/>
                    {resource.completeNotesLabel}
                </button>
            </div>
            <Select
                className={'hrms-notes__select'}
                value={props.sortOptionSelected}
                options={sortOptions}
                onChange={(val)=>props.handleSortChange(val)}
            >

            </Select>

        </div>
    )
}

export default Toolbar;
